// extracted by mini-css-extract-plugin
export default {"wrapper":"calendarWeekHeader_wrapper__6w0D4","item":"calendarWeekHeader_item__Vft6N"};